import React, { useRef, useState, useEffect } from "react";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { Report, TonnageDisclaimer } from "../../../shared";
import { Fragment } from "react";

const schema = yup.object({
  wasteCode: yup.string().required("Waste Code is required."),
  entityType: yup.string().required("Handler Type is required."),
  shipYear: yup.string().required("Ship Year is required."),
  tonsGreaterThan: yup.string(),
});

function EntityAssociationWithSpecificWasteReport() {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const [initialFormValues, setInitialFormValues] = useState({
    wasteCode: params && params.wasteCode ? params.wasteCode : "",
    shipYear: params && params.shipYear ? params.shipYear : "",
    entityType: params && params.entityType ? params.entityType : "",
    tonsGreaterThan: params && params.tonsGreaterThan ? params.tonsGreaterThan : "",
  });
  const [backToUrl, setBacktoUrl] = useState("/reports");
  const [pageTitle, setPageTitle] = useState(
    "Entity Association with a Specific Waste"
  );
  const [apiEndpoint, setApiEndpoint] = useState(
    "/api/v1/hwts/search/facilities/waste-code"
  );

  const formConfig = [
    {
      name: "wasteCode",
      config: {
        col: "md",
        colWidth: "3",
        label: "Waste Code",
        placeholder: "",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/wastecodes/all",
        hasApi: true,
      },
    },
    {
      name: "shipYear",
      config: {
        col: "md",
        validate: true,
        colWidth: "3",
        label: "Select a Ship Year",
        placeholder: "Select a Year",
        type: "year",
      },
    },
    {
      name: "entityType",
      config: {
        col: "md",
        colWidth: "3",
        label: "Handler Type",
        placeholder: "Select a Waste Code",
        type: "select",
        data: [
          { label: "Generator", value: "generator" },
          { label: "Transporter", value: "transporter" },
          { label: "TSDF", value: "tsdf" },
        ],
      },
    },
    {
      name: "tonsGreaterThan",
      config: {
        col: "md",
        colWidth: "3",
        label: "Tons Greater Than",
        placeholder: "Enter tons...",
        type: "text",
      },
    },
  ];

  const customGridCells = [
    {
      columnName: "EpaId",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
  ];

  return (
    <Fragment>
      <Report
        breadcrumb={[
          { name: "HWTS Reports", url: "/reports", active: false },
          { name: pageTitle, url: "", active: true },
        ]}
        backToUrl={backToUrl}
        pageTitle={pageTitle}
        initialFormValues={initialFormValues}
        schema={schema}
        formConfig={formConfig}
        apiEndpoint={apiEndpoint}
        customGridCells={customGridCells}
        searchOnInit={searchOnInit}
      />
      <div className="container">
        <TonnageDisclaimer />
      </div>
    </Fragment>
  );
}

export default EntityAssociationWithSpecificWasteReport;
